'use strict'

import { CMService, UserService } from '../services'

const getDefaultState = () => {
    return {
        currentInqCustomer: undefined,
        newCustomerEntry: undefined,
        saleTransaction: undefined,
        saleInqTransaction: undefined,
        postingSaleTrans: false,
        productFolder: undefined,
        savingSaleOrder: null,
        saleOrderPermissions: [],
        saleDefaults: null,
        error: null
    }
  }
  
  // initial state
  
  const state = getDefaultState()
  
  const actions = {
    resetState ({ commit }) {
      commit('resetState')
    },
    setInquiryCustomer({ commit },customer ) {
        return new Promise((res, rej)  => {
            commit("SET_CUSTOMER_INQ", customer);
            res(true);
        })
    },
    // Product new entry
    
    setNewCustomerCode({commit}, customer_code){
        return new Promise((res, rej) => {
            commit("SET_NEW_CUSTOMER",customer_code);
            res(true);
        })
    },
    setSaleDefaults({commit}) {
      CMService.fetchSaleDefaults()
      .then(({ data }) => commit("SET_SALE_DEFAULT", data))
    },
    insertSaleTranRow({ state, commit }, { productCode, quantity, unitPrice}) {
      let { orderType, orderNumber } = state.saleTransaction ? state.saleTransaction : state.saleInqTransaction
       
      if (!orderType && !orderNumber) return;      

      return CMService.postProduct({ orderType, orderNumber, productCode, quantity, unitPrice })
        .then(({ status, data }) => {
          if (status == 201) {
            return data
          }
        })
    },
    setNewSaleTransaction({ commit }, orderType, documentCode) {
      if (!orderType) {
        commit("SET_NEW_SALE_TRANSACTION");
        return {}
      }
      return CMService.bookNewSaleTransaction({orderType, documentCode})
        .then(({ status, data }) => {
          if (status == 201) {
            commit("SET_NEW_SALE_TRANSACTION",{ orderType: data.order_type, orderNumber: data.order_number});
            return data;
          }
           
        })
    },
    setInqSaleTransaction({commit}, inquiry){
      return new Promise((res, rej) => {
          commit("SET_INQ_SALE_TRANSACTION",inquiry);
          res(true);
      })      
    },
    deleteSaleTransaction({ state, commit }) {      
      let { orderType, orderNumber } = state.saleTransaction ? state.saleTransaction : state.saleInqTransaction
       
      if (!orderType && !orderNumber) return; 
      
      return CMService.deleteBookSaleTransaction(orderType, orderNumber)
        .then(({ status, data }) => {
          if (status == 200) {
            commit("SET_NEW_SALE_TRANSACTION", undefined)
          }
          return { status, data };
        })
    },
    // async saveOpenMasterTrans({ state, commit, dispatch }, {customerCode, orderDate, currencyCode }) {
    //   let orderType, orderNumber
    //   try {
    //     commit("SET_SAVING_SALE_ORDER", true)
        
    //     if (state.saleTransaction) {
    //       orderType = state.saleTransaction.orderType
    //       orderNumber = state.saleTransaction.orderNumber
    //     } else {
    //       orderType = state.saleInqTransaction.orderType
    //       orderNumber = state.saleInqTransaction.orderNumber
    //     }
    //     if (!orderType && !orderNumber) return;
    //   } catch (error) {
    //     commit("SET_SAVING_SALE_ORDER")
    //     commit('SET_ERROR', error)
    //   }
      // console.log('state.saleTransaction',state.saleTransaction)
      // dispatch('getPermissions')
      // .then(({ data }) => {
      //   if (data === 1 || state.saleTransaction) {
      //     return CMService.saveOpenMasterTrans({ orderType, orderNumber, customerCode, orderDate, currencyCode })
      //     .then(({ status }) => {
      //       if (status === 200) {
      //         commit("SET_NEW_SALE_TRANSACTION", undefined)
      //         commit("SET_INQ_SALE_TRANSACTION", undefined)
      //       }
      //     })
      //   // }
      // // })
      // .finally(() => commit("SET_SAVING_SALE_ORDER"))
    postSaleTrans({ commit, dispatch}, data) {
      commit("SET_SALE_POSTING_STATUS", true )
      let  { orderType, orderNumber } = data
      
      // Verifico si tiene permiso para actualizar 
      
        dispatch('saveOpenMasterTrans', data)
        .then(dataSaved => {
          return dataSaved
        })
        .then(() => {        
          CMService.postSaleTrans({ orderNumber , orderType })
          .then(response => { return response })
        })
        .finally(() => {
          commit("SET_SALE_POSTING_STATUS", false )
        })
    },
    getPermissions({ commit, dispatch }) {
      return UserService.getPermission('sale-order', 'u')
    }
  }
  
  const mutations = {
    resetState (state) {     
      Object.assign(state, getDefaultState())
    },
    
    SET_CUSTOMER_INQ(state, customer) {
        state.currentInqCustomer = customer;
        state.newCustomerEntry = undefined;
    },
    SET_NEW_CUSTOMER(state, customer_code) {
        state.newCustomerEntry = customer_code;
        state.currentInqCustomer = undefined;
    },
    SET_SALE_DEFAULT(state, payload) {
      state.saleDefaults = payload
    },
    SET_NEW_SALE_TRANSACTION(state, payload) {
      state.saleTransaction = payload;
    },
    SET_INQ_SALE_TRANSACTION(state, payload) {
      state.saleInqTransaction = payload;
    },
    SET_SAVING_SALE_ORDER(state, payload) {
      state.savingSaleOrder = payload
    },
    SET_SALE_POSTING_STATUS(state, payload) {
      state.postingSaleTrans = payload
    },
    SET_ERROR(state, payload) {
      state.error = payload
    }
  }

  const getters = {
    isCustomerInquiry: state => {
        return state.currentInqCustomer === undefined ? false : true;
    },
    isNewCustomer: state => {
        return state.newCustomerEntry === undefined ? false : true;
    },
    newCustomerEntry: state => {
      return state.newCustomerEntry;
    },
    currentTransaction: state => {
      return state.saleTransaction;
    },
    isInquiryTransaction: state => {
      return state.saleInqTransaction
    },
  }
  
  export const cm = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }


// WEBPACK FOOTER //
// ./src/store/cm.module.js